export const VideoConsultationSelectionPageData = {
  benefits: {
    pkv: [
      {
        header: 'Kostenübernahme für privat & gesetzlich Versicherte',
        text:
          'Die Kosten für Ihre Arztkonsultation und Medikamente werden von Ihrer Krankenkasse übernommen. Für gesetzlich Versicherte gilt die gesetzlich übliche Zuzahlung für Medikamente.'
      },
      {
        header: 'Schnelle Terminvergabe ',
        text: 'Kein langes Warten auf Termine, keine Wartezimmer oder Anfahrtswege.'
      },
      {
        header: 'Medikament schnell erhalten',
        text:
          'Wählen Sie SHOP APOTHEKE als Versandoption und wir liefern Ihr Medikament versandkostenfrei<sup>8</sup> nach Hause.'
      }
    ],
    gkv: [
      {
        header: 'Kostenübernahme für privat & gesetzlich Versicherte',
        text:
          'Die Kosten für Ihre Arztkonsultation und Medikamente werden von Ihrer Krankenkasse übernommen. Für gesetzlich Versicherte gilt die gesetzlich übliche Zuzahlung für Medikamente.'
      },
      {
        header: 'Schnelle Terminvergabe ',
        text: 'Kein langes Warten auf Termine, keine Wartezimmer oder Anfahrtswege.'
      },
      {
        header: 'Medikament schnell erhalten',
        text:
          'Wählen Sie SHOP APOTHEKE als Versandoption und wir liefern Ihr Medikament versandkostenfrei<sup>8</sup> nach Hause.'
      }
    ]
  },

  faqs: {
    gkv: [
      '<strong>Termin buchen:</strong> Wählen Sie Ihre Versicherungsart und Ihren Wunschtermin.',
      '<strong>Registrieren oder Anmelden:</strong> Erstellen Sie ein Patientenkonto oder melden Sie sich mit Ihren bestehenden Anmeldedaten an.',
      '<strong>Ablauf Videosprechstunde:</strong> Sie erhalten eine Terminbestätigung mit einem Link, über den Sie sich in die Videosprechstunde einwählen können. Loggen Sie sich zur vereinbarten Zeit in die Videosprechstunde ein, und warten Sie auf den Arzt. In Ausnahmefällen kann das auch mal einige Minuten dauern. Bei Bedarf kann der Arzt ein e-Rezept oder eine Krankschreibung ausstellen.',
      '<strong>E-Rezept einlösen:</strong> Wählen Sie SHOP APOTHEKE als Versandoption, liefern wir Ihnen Ihr Medikament versandkostenfrei<sup>8</sup> nach Hause.'
    ],
    pkv: [
      'Wählen Sie Ihre Versicherungsart.',
      'Wählen Sie Ihren Online-Arzt-Anbieter für die Videosprechstunde aus.',
      'Laden Sie sich die App Ihres Anbieters kostenlos auf Ihrem Smartphone runter.',
      'Vereinbaren Sie anschließend Ihren Wunschtermin. In der Regel sind Termine noch am selben Tag verfügbar.',
      'Die Videosprechstunde erfolgt direkt in der App.'
    ]
  }
};
